import { useEffect, useState } from "react";
import axios from "axios";
import { Download, FileText, Loader2 } from "lucide-react";
import { getAuthHeader } from "@/App";
import { fsize } from "./chatApi";

const cache = new Map();

const useBlob = (url, load) => {
  const [src, setSrc] = useState(cache.get(url) || null);
  useEffect(() => {
    if (!load || src || !url) return;
    let off = false;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}${url}`, { headers: getAuthHeader(), responseType: "blob" })
      .then((r) => { const u = URL.createObjectURL(r.data); cache.set(url, u); if (!off) setSrc(u); }).catch(() => {});
    return () => { off = true; };
  }, [url, load, src]);
  return src;
};

export const Attachment = ({ m, onImage }) => {
  const media = ["image", "video", "audio"].includes(m.file_type);
  const src = useBlob(m.file_url, media);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${m.file_url}`, { headers: getAuthHeader(), responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = m.file_name || "file"; a.click();
    } finally { setBusy(false); }
  };
  if (!m.file_url) return null;
  if (media && !src) return <div className="mt-2 flex h-24 w-48 items-center justify-center rounded-lg bg-slate-100"><Loader2 className="h-4 w-4 animate-spin text-slate-400" /></div>;
  if (m.file_type === "image") return <img src={src} alt={m.file_name} onClick={() => onImage?.(src)} className="mt-2 max-h-56 max-w-[280px] cursor-zoom-in rounded-lg object-cover" data-testid={`chat-img-${m.id}`} />;
  if (m.file_type === "video") return <video src={src} controls className="mt-2 max-h-64 max-w-[320px] rounded-lg bg-black" data-testid={`chat-video-${m.id}`} />;
  if (m.file_type === "audio") return <audio src={src} controls className="mt-2 w-64" />;
  return (
    <button onClick={download} className="mt-2 flex items-center gap-2 rounded-lg border bg-white px-3 py-2 text-left text-sm hover:bg-slate-50" data-testid={`chat-file-${m.id}`}>
      <FileText className="h-5 w-5 text-indigo-500" /><span className="min-w-0"><span className="block max-w-[220px] truncate font-medium">{m.file_name}</span><span className="text-xs text-slate-400">{fsize(m.file_size)}</span></span>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4 text-slate-400" />}
    </button>
  );
};
